import { Environment } from '@front/shared/util-environment';
import * as Sentry from '@sentry/browser';

const production = import.meta.env.NODE_ENV === 'production';
const cmsBaseUrl = import.meta.env.FRONT_CMS_BASE_URL.replace(/\/$/, '');
const apiVersion = import.meta.env.FRONT_CMS_API_VERSION;

export const environment: Environment = {
  production,
  cmsBaseUrl,
  cmsApiUrl: `${cmsBaseUrl}/${apiVersion}`,
};

export const sentryOptions: Sentry.BrowserOptions = {
  //dsn: import.meta.env.FRONT_SENTRY_DSN,
  //release: import.meta.env.FRONT_SENTRY_RELEASE,
  //environment: import.meta.env.FRONT_SENTRY_ENVIRONMENT,
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Registers the Replay integration,
    // which automatically captures Session Replays
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // We recommend adjusting this value in production
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ['localhost', new RegExp(`^${cmsBaseUrl}`)],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
};
